import { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Button, Input, Modal } from 'antd'
import { useNotification } from '@/Ship/Hooks/useNotification'
import { ReportDelayModalStore } from '../../Stores/ReportDelayModalStore'

interface ReportDelayModalProps {
    assignmentUuid: string
    open: boolean
    onClose: () => void
    onReported: () => void
}

export const ReportDelayModal = observer(({ assignmentUuid, open, onClose, onReported }: ReportDelayModalProps) => {
    const [store] = useState(() => new ReportDelayModalStore())
    const { showSuccess, showError } = useNotification()

    const handleSubmit = async () => {
        const ok = await store.submit(assignmentUuid, { success: showSuccess, error: showError })
        if (ok) {
            onReported()
            onClose()
        }
    }

    return (
        <Modal
            open={open}
            title="Повідомити про затримку виконання"
            onCancel={onClose}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Скасувати
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    danger
                    loading={store.loading}
                    disabled={!store.comment.trim()}
                    onClick={handleSubmit}
                >
                    Відправити
                </Button>,
            ]}
        >
            <Input.TextArea
                rows={4}
                placeholder="Коментар водія про причину затримки *"
                value={store.comment}
                onChange={(e) => store.setComment(e.target.value)}
            />
        </Modal>
    )
})
